import { GridTableEmptyList, GridTableScroll } from "@/modules/common/components";
import PaginationCompact from "@/modules/common/components/files/PaginationCompact";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminAuditLogListResponse } from "@/service/response/admin-audit-logs";
import LogsListHeader from "./LogsListHeader";
import LogsListLine from "./LogsListLine";
import LogsListSkeleton from "./LogsListSkeleton";

interface LogsListParams {
  data?: Pagination<AdminAuditLogListResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const LogsList = ({ data, isLoading = false, isFetching = false, limit = 20, onChangePage, onChangePageSize }: LogsListParams) => {
  return (
    <>
      {isLoading || data === undefined ? (
        <LogsListSkeleton limit={limit} />
      ) : !!data ? (
        <>
          {!data.values.length ? (
            <GridTableEmptyList />
          ) : (
            <div className="w-full bg-white rounded-lg shadow overflow-hidden relative">
              {isFetching && <div className="absolute inset-0 bg-white/50 z-10 pointer-events-none transition-opacity" />}

              <GridTableScroll minWidthClassName="md:min-w-[960px]">
                <LogsListHeader />

                <div className="divide-y divide-gray-100 md:divide-y-0">
                  <div className="flex flex-col gap-3 p-3 md:p-0 md:gap-0">
                    {data.values.map((log) => (
                      <LogsListLine key={log.id} log={log} />
                    ))}
                  </div>
                </div>
              </GridTableScroll>

              <div className="px-3 sm:px-5 py-3 border-t border-ui-border">
                <PaginationCompact metadata={data.metadata} onChangePage={onChangePage} onChangePageSize={onChangePageSize} />
              </div>
            </div>
          )}
        </>
      ) : null}
    </>
  );
};

export default LogsList;
